import React from 'react'
import EditSvg from 'images/modules/Manage/i-edit.svg?raw'

export { default as EditUrl } from 'images/modules/Manage/i-edit.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: EditSvg}} />
)
